import { mode } from "@chakra-ui/theme-tools";
export const globalStylesDev = {
  colors: {
    brand: {
      50: "#e4f3f6",
      100: "#bee1ea",
      200: "#aad9e4",
      300: "#97d0de",
      400: "#84c7d7",
      500: window.config.tenant === "Jae" ? "#5db6cb" : "#2A85BD",
      600: window.config.tenant === "Jae" ? "#5db6cb" : "#2A85BD",
      700: window.config.tenant === "Jae" ? "#3ca1b9" : "#2A85BD",
      800: window.config.tenant === "Jae" ? "#3ca1b9" : "#2A85BD",
      900: window.config.tenant === "Jae" ? "#3591a6" : "#2A85BD",
    },
    brandScheme: {
      50: "#50e4ff",
      100: "#1ddcff",
      200: "#03d8ff",
      300: "#00c5e9",
      400: "#00afcf",
      500: "#00849c",
      600: "#005969",
      700: "#004350",
      800: "#002e36",
      900: "#000303",
    },
    brandTabs: {
      50: "#ffffff",
      100: "#ffffff",
      200: "#ffffff",
      300: "#eff9fb",
      400: "#daf1f7",
      500: "#b1e1ed",
      600: "#88d1e3",
      700: "#73c9df",
      800: "#5ec1da",
      900: "#35b1d0",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#4ecce1",
      100: "#24bed8",
      200: "#21abc2",
      300: "#1d98ac",
      400: "#198497",
      500: "rgba(18, 94, 107, 1)",
      600: "#0b383f",
      700: "#07242a",
      800: "rgba(18, 94, 107, 1)",
      900: "#000000",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  styles: {
    global: (props: any) => ({
      body: {
        overflowX: "hidden",
        bg: mode("#F4F7FE", "navy.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
        color: mode("gray.700", "white")(props),
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-track": {
          width: "10px",
          background: mode("#f1f1f1", "navy.900")(props),
        },
        "&::-webkit-scrollbar-thumb": {
          background: mode("#cbd5e0", "gray.600")(props),
          borderRadius: "24px",
        },
      },
      input: {
        color: "gray.700",
        _focus: {
          borderColor: "brand.500",
          boxShadow: "0 0 0 1px brand.500",
        },
      },
      button: {
        _active: {
          transform: "scale(0.98)",
        },
      },
      html: {
        fontFamily: "DM Sans",
      },
      rdrDefinedRangesWrapper: {
        display: "none",
      },
    }),
  },
};

export const globalStylesHomolog = {
  colors: {
    brand: {
      50: "#e4f3f6",
      100: "#bee1ea",
      200: "#aad9e4",
      300: "#97d0de",
      400: "#84c7d7",
      500: window.config.tenant === "Jae" ? "#5db6cb" : "#2A85BD",
      600: window.config.tenant === "Jae" ? "#5db6cb" : "#2A85BD",
      700: window.config.tenant === "Jae" ? "#3ca1b9" : "#2A85BD",
      800: window.config.tenant === "Jae" ? "#3ca1b9" : "#2A85BD",
      900: window.config.tenant === "Jae" ? "#3591a6" : "#2A85BD",
    },
    brandScheme: {
      50: "#50e4ff",
      100: "#1ddcff",
      200: "#03d8ff",
      300: "#00c5e9",
      400: "#00afcf",
      500: "#00849c",
      600: "#005969",
      700: "#004350",
      800: "#002e36",
      900: "#000303",
    },
    brandTabs: {
      50: "#ffffff",
      100: "#ffffff",
      200: "#ffffff",
      300: "#eff9fb",
      400: "#daf1f7",
      500: "#b1e1ed",
      600: "#88d1e3",
      700: "#73c9df",
      800: "#5ec1da",
      900: "#35b1d0",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#4ecce1",
      100: "#24bed8",
      200: "#21abc2",
      300: "#1d98ac",
      400: "#198497",
      500: "rgba(18, 94, 107, 1)",
      600: "#0b383f",
      700: "#07242a",
      800: "rgba(18, 94, 107, 1)",
      900: "#000000",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  styles: {
    global: (props: any) => ({
      body: {
        overflowX: "hidden",
        bg: mode("#F4F7FE", "navy.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
        color: mode("gray.700", "white")(props),
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-track": {
          width: "10px",
          background: mode("#f1f1f1", "navy.900")(props),
        },
        "&::-webkit-scrollbar-thumb": {
          background: mode("#cbd5e0", "gray.600")(props),
          borderRadius: "24px",
        },
      },
      input: {
        color: "gray.700",
        _focus: {
          borderColor: "brand.500",
          boxShadow: "0 0 0 1px brand.500",
        },
      },
      button: {
        _active: {
          transform: "scale(0.98)",
        },
      },
      html: {
        fontFamily: "DM Sans",
      },
      rdrDefinedRangesWrapper: {
        display: "none",
      },
    }),
  },
};

export const globalStylesSupervia = {
  colors: {
    brand: {
      50: "#e4f3f6",
      100: "#bee1ea",
      200: "#aad9e4",
      300: "#97d0de",
      400: "#84c7d7",
      500: window.config.tenant === "Jae" ? "#5db6cb" : "#2A85BD",
      600: window.config.tenant === "Jae" ? "#5db6cb" : "#2A85BD",
      700: window.config.tenant === "Jae" ? "#3ca1b9" : "#2A85BD",
      800: window.config.tenant === "Jae" ? "#3ca1b9" : "#2A85BD",
      900: window.config.tenant === "Jae" ? "#3591a6" : "#2A85BD",
    },
    brandScheme: {
      50: "#50e4ff",
      100: "#1ddcff",
      200: "#03d8ff",
      300: "#00c5e9",
      400: "#00afcf",
      500: "#00849c",
      600: "#005969",
      700: "#004350",
      800: "#002e36",
      900: "#000303",
    },
    brandTabs: {
      50: "#ffffff",
      100: "#ffffff",
      200: "#ffffff",
      300: "#eff9fb",
      400: "#daf1f7",
      500: "#b1e1ed",
      600: "#88d1e3",
      700: "#73c9df",
      800: "#5ec1da",
      900: "#35b1d0",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#4ecce1",
      100: "#24bed8",
      200: "#21abc2",
      300: "#1d98ac",
      400: "#198497",
      500: "rgba(18, 94, 107, 1)",
      600: "#0b383f",
      700: "#07242a",
      800: "rgba(18, 94, 107, 1)",
      900: "#000000",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  styles: {
    global: (props: any) => ({
      body: {
        overflowX: "hidden",
        bg: mode("#F4F7FE", "navy.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
        color: mode("gray.700", "white")(props),
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-track": {
          width: "10px",
          background: mode("#f1f1f1", "navy.900")(props),
        },
        "&::-webkit-scrollbar-thumb": {
          background: mode("#cbd5e0", "gray.600")(props),
          borderRadius: "24px",
        },
      },
      input: {
        color: "gray.700",
        _focus: {
          borderColor: "brand.500",
          boxShadow: "0 0 0 1px brand.500",
        },
      },
      button: {
        _active: {
          transform: "scale(0.98)",
        },
      },
      html: {
        fontFamily: "DM Sans",
      },
      rdrDefinedRangesWrapper: {
        display: "none",
      },
    }),
  },
};

export const globalStylesJae = {
  colors: {
    brand: {
      50: "#c1f2ee",
      100: "#97e9e3",
      200: "#82e5dd",
      300: "#6de0d7",
      400: "#58dcd1",
      500: window.config.tenant === "Jae" ? "#5db6cb" : "#2A85BD",
      600: "#24aaa0",
      700: "#1f958c",
      800: "#1b8078",
      900: "#125651",
    },
    brandScheme: {
      50: "#c1f2ee",
      100: "#97e9e3",
      200: "#82e5dd",
      300: "#6de0d7",
      400: "#58dcd1",
      500: "#2ED3C6",
      600: "#24aaa0",
      700: "#1f958c",
      800: "#1b8078",
      900: "#125651",
    },
    brandTabs: {
      50: "#ffffff",
      100: "#ffffff",
      200: "#ffffff",
      300: "#eff9fb",
      400: "#daf1f7",
      500: "#b1e1ed",
      600: "#88d1e3",
      700: "#73c9df",
      800: "#5ec1da",
      900: "#35b1d0",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#595959",
      100: "#404040",
      200: "#333333",
      300: "#262626",
      400: "#1a1a1a",
      500: "rgba(0, 0, 0, 1)",
      600: "#000000",
      700: "#000000",
      800: "#000000",
      900: "#000000",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  styles: {
    global: (props: any) => ({
      body: {
        overflowX: "hidden",
        bg: mode("#F4F7FE", "navy.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
        color: mode("gray.700", "white")(props),
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-track": {
          width: "10px",
          background: mode("#f1f1f1", "navy.900")(props),
        },
        "&::-webkit-scrollbar-thumb": {
          background: mode("#cbd5e0", "gray.600")(props),
          borderRadius: "24px",
        },
      },
      input: {
        color: "#000000",
        _focus: {
          borderColor: "brand.500",
          boxShadow: "0 0 0 1px brand.500",
        },
      },
      button: {
        _active: {
          transform: "scale(0.98)",
        },
      },
      html: {
        fontFamily: "DM Sans",
      },
      rdrDefinedRangesWrapper: {
        display: "none",
      },
    }),
  },
};
